import { ApplicationInitStatus, Injectable, inject } from '@angular/core';
import { AnalyticsService } from '@lite-workspace/shared/services/analytics';
import { isBffMode, probeBffSession } from '@lite-workspace/shared/session';
import { AuthIdentityService } from './auth-identity.service';

@Injectable({ providedIn: 'root' })
export class AnalyticsIdentityService {
  private readonly analytics = inject(AnalyticsService);
  private readonly authIdentity = inject(AuthIdentityService);

  constructor() {
    // Set at construction, not inside identify: events fired before the session resolves already need it.
    this.analytics.setGlobalProperties({ product: 'gallery' });
    // initAuthMode() is a sibling app initializer: until it settles, load() would read the wrong auth mode.
    void inject(ApplicationInitStatus).donePromise.then(() => this.classifySession());
  }

  private async classifySession(): Promise<void> {
    // Anonymous only on a definite «no session»: a failed whoami ('unknown') may hide a signed-in internal
    // account, so it keeps transmission closed.
    const bff = isBffMode();
    if (bff && (await probeBffSession()) === 'dead') return this.analytics.openAnonymousTransmission();

    const { userId, email } = await this.authIdentity.load();
    if (userId) {
      this.analytics.identify({ profileId: userId, email: email ?? undefined, properties: { app: 'gallery' } });
    } else if (!bff) {
      this.analytics.openAnonymousTransmission();
    }
  }
}
